import React, { Fragment } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Alert,
    Row,
    Col,
    Label,
    FormFeedback,
    Input,
    FormText
} from 'reactstrap';

import { Utils } from "custom";
import { TeacherAPI } from "api";

class AddTeacher extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                firstname: '',
                lastname: '',
                email: '',
                cell: '',
                permissions: []
            },
            loading: false,
            errors: false,
            roles: ["TEACHER", "TUTOR", "STAGE", "TRIAL"],
        };
    }

    componentDidMount() {
        this.resetForm();
    }

    changeForm(key, text) {
        const form = this.state.form;

        if (key === "permissions") {
            if (text.value) {
                console.log('text.key',form);
                form.permissions.push(text.key);
            } else {
                for (let i = 0; i < form.permissions.length; i++) {
                    if (form.permissions[i] === text.key)
                        form.permissions.splice(i, 1);
                }
            }
        } else {
            form[key] = text;
        }

        this.setState({ form: form }, () => this.showModal());
    }

    showModal() {
        let form = this.state.form;
        let errors = this.state.errors;

        global.onSetModal({
            title: this.props.label,
            content: <div>
                <Row>
                    <Col md="6">
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Nome
                            </Label>
                            <Input type="text" value={form.firstname}
                                invalid={Boolean(errors.firstname)}
                                onChange={(e) => this.changeForm('firstname', e.target.value)} />
                            <FormFeedback>{errors.firstname}</FormFeedback>
                        </div>
                    </Col>
                    <Col md="6">
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Cognome
                            </Label>
                            <Input type="text" value={form.lastname}
                                invalid={Boolean(errors.lastname)}
                                onChange={(e) => this.changeForm('lastname', e.target.value)} />
                            <FormFeedback>{errors.lastname}</FormFeedback>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Email
                            </Label>
                            <Input type="email" value={form.email}
                                invalid={Boolean(errors.email)}
                                onChange={(e) => this.changeForm('email', e.target.value)} />
                            <FormFeedback>{errors.email}</FormFeedback>
                        </div>
                    </Col>
                    <Col md="12">
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Cellulare
                            </Label>
                            <Input
                                type="tel"
                                value={form.cell}
                                invalid={Boolean(errors.cell)}
                                onChange={(e) => this.changeForm('cell', e.target.value)} />
                            <FormFeedback>{errors.cell}</FormFeedback>
                            <FormText>
                                Assicurati di digitare correttamente il <u>numero di cellulare</u>, è necessario inserire anche il prefisso internazionale (+39 per Italia)
                            </FormText>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <h5>Permessi</h5>
                        <div className={Boolean(errors.permissions) ? 'is-invalid mb-2': ' mb-2 '}>
                            {this.state.roles.map((el, i) => {
                                return (
                                    <div className="form-check form-check-outline form-check-primary mb-3" key={i}>
                                        <Input className="form-check-input"
                                            type="checkbox"
                                            id={i}
                                            checked={this.state.form?.permissions?.includes(el)}
                                            onChange={(e) => this.changeForm('permissions', { key: el, value: e.target.checked })}
                                        />
                                        <Label className="form-check-label" htmlFor={i}>
                                            {el}
                                        </Label>
                                    </div>
                                )
                            })}
                        </div>
                        <FormFeedback>{errors.permissions}</FormFeedback>
                    </Col>
                </Row>
            </div>,
            isOpen: true,
            toggle: false,
            size: 'lg',
            type: 'info',
            buttons: [
                { label: 'SALVA', color: 'success', onClick: () => this.saveUser() },
                {
                    label: 'CHIUDI',
                    color: 'danger',
                    onClick: () => this.resetForm()
                },
            ]
        })
    }

    resetForm() {
        this.setState({
            form: {
                id: "",
                firstname: "",
                lastname: "",
                email: "",
                cell:  "",
                permissions: []
            }
        }, () => {
            global.onSetModal({ isOpen: false });
        });
    }

    saveUser() {
        const self = this;
        let form = this.state.form;
        let error = {};

        if (form.firstname === '')
            error.firstname = "Il campo nome è obbligatorio";

        if (form.lastname === '')
            error.lastname = "Il campo cognome è obbligatorio";

        if (form.email === '')
            error.email = "Il campo email è obbligatorio";

        if (form.cell === '')
            error.cell = "Il campo cellulare è obbligatorio";

        if (!Utils.isValidEmail(form.email))
            error.email = "La mail inserita non è corretta";

        if (form.cell !== '' && !Utils.isValidPhone(form.cell))
            error.cell = "Il telefono inserito non è corretto";

        if (!form.permissions.length)
            error.permissions = "Il permissions inserito non è corretto";

        this.setState({ errors: error }, () => this.showModal());

        if (Object.keys(error).length === 0) {
            global.onSetModal({ loading: true });
            console.log('form',form);
            TeacherAPI.add(form).then(() => {
                global.onSetModal({ loading: false });
                global.SweetAlert.fire({
                    title: 'Utente creato',
                    text: 'L\'utente è stato creato correttamente, è stata inviata una email per procedere con la registrazione.',
                    icon: 'success',
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'btn btn-primary'
                    },
                    confirmButtonText: 'Chiudi',
                    buttonsStyling: false
                })
                self.props.onResolve();
                self.resetForm()
            }).catch((error) => {
                console.log('error',error);
                global.onSetModal({ loading: false });
                global.SweetAlert.fire({
                    title: 'Errore',
                    text: 'Si è verificato un errore durante la creazione dell\'utente',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-primary'
                    }
                });
            })
        }
    }


    render() {
        return (
            <React.Fragment>
                <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={() => this.showModal()}>
                    <i className="ri-add-line align-bottom me-1"></i> {this.props.label}
                </button>
            </React.Fragment>
        )
    }
}

export default AddTeacher;
